import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["month", "grid"]
  static values = { noticeDates: Array }

  connect() {
    this.currentDate = new Date()
    this.render()
  }

  prevMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() - 1)
    this.render()
  }

  nextMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() + 1)
    this.render()
  }

  render() {
    // Month label
    const options = { month: "long", year: "numeric" }
    this.monthTarget.textContent = this.currentDate.toLocaleDateString("en-US", options)

    // Calendar calculations
    const firstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1)
    const lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0)

    // Start day index for Monday = 0
    let startDay = firstDay.getDay() - 1
    if (startDay < 0) startDay = 6

    const totalDays = lastDay.getDate()
    let html = ""

    // Days of the week header
    const daysOfWeek = ["Mo","Tu","We","Th","Fr","Sa","Su"]
    daysOfWeek.forEach(d => {
      html += `<div class="text-gray-500 font-medium py-2">${d}</div>`
    })

    // Leading blanks from previous month
    for (let i = 0; i < startDay; i++) {
      html += `<div class="py-2 text-gray-400"></div>`
    }

    // Current month days
    for (let day = 1; day <= totalDays; day++) {
      const date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), day)
      const classes = ["py-2"]

      // Highlight today
      const today = new Date()
      if (
        day === today.getDate() &&
        this.currentDate.getMonth() === today.getMonth() &&
        this.currentDate.getFullYear() === today.getFullYear()
      ) {
        classes.push("bg-indigo-900 text-white rounded")
      }

      // Highlight notice/event dates
      if (this.noticeDatesValue.some(d => new Date(d).toDateString() === date.toDateString())) {
        classes.push("bg-yellow-100 text-yellow-900 rounded font-semibold")
      }

      html += `<div class="${classes.join(" ")}">${day}</div>`
    }

    this.gridTarget.innerHTML = html
  }
}
